import React from "react";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { Sparkles, ArrowRight } from "lucide-react";
import ScoreBars from "@/components/ScoreBars";

export const DecodeMiniCard = ({ data, decodeType }) => {
  if (!data) return null;
  const mini = data.mini;
  const scores = data.rule_output?.scores;
  return (
    <div className="litra-card p-5 sm:p-6 fade-in" data-testid="decode-mini-card"
      style={{ borderColor: "rgba(20,90,67,0.4)" }}>
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div>
          <div className="text-xs text-[var(--bone-faint)] mono-chip uppercase">{decodeType}</div>
          <h3 className="text-2xl font-display font-semibold mt-1">{data.input_text}</h3>
        </div>
        <Badge className="gold-edge gold-text bg-transparent" data-testid="decode-xp-badge">
          <Sparkles className="w-3 h-3 mr-1" /> +{mini.xp_earned} XP
        </Badge>
      </div>

      <p className="mt-3 text-[var(--bone-muted)] leading-relaxed">{mini.overview}</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-4">
        <div className="rounded-xl bg-white/[0.03] border border-white/[0.06] p-3">
          <div className="mono-chip text-[var(--bone-faint)]">LITRAROOT</div>
          <div className="mt-1 text-sm">{mini.litraroot}</div>
        </div>
        <div className="rounded-xl bg-white/[0.03] border border-white/[0.06] p-3">
          <div className="mono-chip text-[var(--bone-faint)]">LITRASEAL</div>
          <div className="mt-1 text-sm">{mini.litraseal}</div>
        </div>
      </div>

      <div className="mt-4">
        <div className="mono-chip text-[var(--bone-faint)] mb-2">TOP LETTER SIGNALS</div>
        <div className="flex flex-wrap gap-2">
          {mini.top_letter_signals?.map((s, i) => (
            <span key={i} className="glass rounded-full px-3 py-1 mono-chip" data-testid={`signal-${s.letter}`}>
              <span className="green-text font-semibold">{s.letter}</span> · {s.technical_name}
            </span>
          ))}
        </div>
      </div>

      <Separator className="my-4 bg-white/[0.06]" />
      <div className="flex items-center justify-between flex-wrap gap-2">
        <Badge variant="outline" className="border-[rgba(185,192,204,0.3)]">{mini.word_class}</Badge>
        <span className="text-xs text-[var(--bone-faint)]">Archetype · <span className="text-[var(--bone)]">{mini.archetype}</span></span>
      </div>

      <div className="mt-4">
        <div className="mono-chip text-[var(--bone-faint)] mb-2">SCORE HIGHLIGHTS</div>
        <ScoreBars scores={scores} compact limit={3} />
      </div>

      <div className="mt-4 flex items-start gap-2 text-sm text-[var(--bone-muted)]">
        <ArrowRight className="w-4 h-4 mt-0.5 green-text shrink-0" />
        <span>{mini.suggested_next_mission}</span>
      </div>
    </div>
  );
};

export default DecodeMiniCard;
